import { Image, Typography } from "antd";
import uxloader from "../../assets/images/uxloader.gif";
import I18Provider from "../../i18n/I18Provider";
import { useTranslation } from "react-i18next";

export default function UXloader({ lang = "en" }) {
  const { t } = useTranslation();

  return (
    <I18Provider lang={lang}>
      <div className='h-100vh flex-item flex-center flex-column bg-white'>
        <Image src={uxloader} style={{ width: 80 }} preview={false} />
        <Typography.Paragraph className='m-0'>{t("loading")}</Typography.Paragraph>
      </div>
    </I18Provider>
  );
}
